import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useGetMeQuery } from '@@/services/user';

const Footer: React.FC = () => {
  const { data: me } = useGetMeQuery();

  if (!me) {
    return null;
  }

  return (
    <div className="p-3">
      <Link
        to="/me"
        className="group flex items-center space-x-2 p-2 bg-gray-50 hover:bg-gray-100 rounded-lg transition-all duration-200 border border-gray-200 hover:border-gray-300"
      >
        {/* Avatar */}
        <div className="flex-shrink-0">
          {me.partner?.icon ? (
            <img
              src={me.partner.icon}
              className="w-6 sm:w-10 bg-white font-main p-1 rounded"
            />
          ) : (
            <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center shadow-sm">
              <span className="text-white font-semibold text-sm">
                {me.name}
              </span>
            </div>
          )}
        </div>

        {/* Informations utilisateur */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-1">
            <p className="text-sm font-medium text-gray-900 whitespace-nowrap overflow-hidden text-ellipsis">
              {me.name}
            </p>
            {/* Badge de statut */}
            <div className="w-1.5 h-1.5 bg-green-500 rounded-full flex-shrink-0" />
          </div>
          <p className="text-xs text-gray-600 whitespace-nowrap overflow-hidden text-ellipsis">
            {me.partner?.name}
          </p>
        </div>

        {/* Badge Mon profil */}
        <div className="flex items-center space-x-2 flex-shrink-0">
          <ChevronRight
            size={14}
            className="text-gray-400 group-hover:text-gray-600 transition-colors"
          />
        </div>
      </Link>
    </div>
  );
};

export default Footer;
